import {vrmVueModule} from '../module';
import camelCase from 'camel-case';

/**
 * Registers a given component as an angular component, the directive pattern becomes:
 * `<${component.name}>`
 * @param {Vue} component
 */
function generateComponentDirective(component) {
    const directiveName = camelCase(component.angularDirective);
    console.info('[shared-components] Registering vue component', directiveName);
    vrmVueModule.directive(directiveName, /* @ngInject */(createVueComponent) => {
        const $compile = createVueComponent(component);
        const model = component.options.model;
        // If the component defines a v-model setup then we add magic
        if (model) {
            // Add the ngModel controller, we receive it in .link()
            $compile.require = '?ngModel';
            const ngVueLinker = $compile.link;
            // Inject $attr bindings to link v-model to ng-model
            $compile.link = ($scope, $element, $attr, controller) => {
                // If the controller is actually bound then setup the bridge
                if (controller) {
                    // Bind underlying property of v-model
                    const propName = camelCase(`v-props-${model.prop}`);
                    console.assert(!$attr[propName], `Vue component with ng-model also has ${propName} bound!`);
                    $attr[propName] = () => {
                        return controller.$viewValue;
                    };
                    // Bind v-model event handler
                    const eventName = camelCase(`v-on-${model.event}`);
                    console.assert(!$attr[eventName], `Vue component with ng-model also has ${eventName} bound!`);
                    $attr[eventName] = () => {
                        return function handleVModel(value) {
                            controller.$setViewValue(value);
                        }
                    };
                }
                ngVueLinker($scope, $element, $attr);
            };
        }

        return $compile;
    });
}

// Create a dynamic include, which imports all .vue files (recursivly) under the supplied path
const context = require.context('@/vue/components/shared/', true, /\.vue$/);

context.keys()
    // Imports/executes each module with the dynamic context
    .map(context)
    // For each executed module, grab the default export of that module
    .map(exports => exports.default)
    // Only keep the exported components that are marked by the angular directive
    .filter(component => component.angularDirective)
    // Generate an angular directive for all remaining components
    .forEach(generateComponentDirective);
